import { render, staticRenderFns } from "./BlogTypes.vue?vue&type=template&id=28d329f5&scoped=true&"
import script from "./BlogTypes.vue?vue&type=script&lang=js&"
export * from "./BlogTypes.vue?vue&type=script&lang=js&"
import style0 from "./BlogTypes.vue?vue&type=style&index=0&id=28d329f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d329f5",
  null
  
)

export default component.exports